var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadJson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26626_137415",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26626_137415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 13.9987L14.6665 11.332L13.7332 10.3987L12.6665 11.4654V8.68203H11.3332V11.4654L10.2665 10.3987L9.33317 11.332L11.9998 13.9987ZM9.33317 15.9987V14.6654H14.6665V15.9987H9.33317ZM3.99984 13.332C3.63317 13.332 3.31928 13.2015 3.05817 12.9404C2.79706 12.6793 2.6665 12.3654 2.6665 11.9987V2.66536C2.6665 2.2987 2.79706 1.98481 3.05817 1.7237C3.31928 1.46259 3.63317 1.33203 3.99984 1.33203H8.6665L12.6665 5.33203V7.3487H11.3332V5.9987H7.99984V2.66536H3.99984V11.9987H7.99984V13.332H3.99984Z",
    fill: "#495057"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadJson);
export default __webpack_public_path__ + "static/media/download-json.b346bab065f8508eb35f6e6590ba7916.svg";
export { ForwardRef as ReactComponent };